import React from "react";
import "./index.scss";

import logo from "./../../images/logo.svg";
import logoText from "./../../images/logo_text.svg";

import { NavLink } from "react-router-dom";

const Navbar = function Navbar() {
  return (
    <nav>
      <div className="sidebar__logo">
        <NavLink to="/" className="navlink">
          <img src={logo} alt="jveliz-logo" width="24px" />
          <img src={logoText} alt="jveliz-logo_text" width="36px" />
        </NavLink>
      </div>

      <div className="sidebar__main">
        <ul>
          <li>
            <NavLink to="/">
              <i className="fa fa-home" aria-hidden="true"></i>
              <span>Inicio</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/cv">
              <i className="fa fa-file-text-o" aria-hidden="true"></i>
              <span>CV</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/projects">
              <i className="fa fa-eye" aria-hidden="true"></i>
              <span>Proyectos</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="sidebar__social-media">
        <ul>
          <li>
            <a
              href="https://twitter.com/JoseVzFr"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fa fa-twitter"></i>
            </a>
          </li>
          <li>
            <a
              href="https://github.com/ZetaGH"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fa fa-github"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/jmvf/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fa fa-linkedin"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
